export const font = {
  "font_title_primary": {
    "fontSize": 24,
    "fontWeight": "Medium",
    "lineHeight": 30
  },
  "font_title_subtitle": {
    "fontSize": 20,
    "fontWeight": "Medium",
    "lineHeight": 24
  },
  "font_title_secondary": {
    "fontSize": 17,
    "fontWeight": "Medium",
    "lineHeight": 21
  },
  "font_title_list": {
    "fontSize": 16,
    "fontWeight": "Medium",
    "lineHeight": 24
  },
  "font_text_plain": {
    "fontSize": 15,
    "fontWeight": "Medium",
    "lineHeight": 23
  },
  "font_text_description": {
    "fontSize": 14,
    "fontWeight": "Medium",
    "lineHeight": 21
  },
  "font_text_auxiliary": {
    "fontSize": 12,
    "fontWeight": "Regular",
    "lineHeight": 18
  },
  "font_text_least": {
    "fontSize": 10,
    "fontWeight": "Regular",
    "lineHeight": 12
  },
  "font_text_nunmber": {
    "fontSize": 14,
    "fontWeight": "Regular",
    "lineHeight": 0
  },
  "font_grade_1_medium": {
    "fontSize": 24,
    "fontWeight": "Medium",
    "lineHeight": 34
  },
  "font_grade_1_regular": {
    "fontSize": 24,
    "fontWeight": "Regular",
    "lineHeight": 34
  },
  "font_grade_2_medium": {
    "fontSize": 20,
    "fontWeight": "Medium",
    "lineHeight": 28
  },
  "font_grade_2_regular": {
    "fontSize": 20,
    "fontWeight": "Regular",
    "lineHeight": 28
  },
  "font_grade_3_medium": {
    "fontSize": 18,
    "fontWeight": "Medium",
    "lineHeight": 26
  },
  "font_grade_3_regular": {
    "fontSize": 18,
    "fontWeight": "Regular",
    "lineHeight": 26
  },
  "font_grade_4_medium": {
    "fontSize": 17,
    "fontWeight": "Medium",
    "lineHeight": 25
  },
  "font_grade_4_regular": {
    "fontSize": 17,
    "fontWeight": "Regular",
    "lineHeight": 25
  },
  "font_grade_5_medium": {
    "fontSize": 16,
    "fontWeight": "Medium",
    "lineHeight": 24
  },
  "font_grade_5_regular": {
    "fontSize": 16,
    "fontWeight": "Regular",
    "lineHeight": 24
  },
  "font_grade_6_medium": {
    "fontSize": 15,
    "fontWeight": "Medium",
    "lineHeight": 23
  },
  "font_grade_6_regular": {
    "fontSize": 15,
    "fontWeight": "Regular",
    "lineHeight": 23
  },
  "font_grade_7_medium": {
    "fontSize": 14,
    "fontWeight": "Medium",
    "lineHeight": 21
  },
  "font_grade_7_regular": {
    "fontSize": 14,
    "fontWeight": "Regular",
    "lineHeight": 21
  },
  "font_grade_8_medium": {
    "fontSize": 12,
    "fontWeight": "Medium",
    "lineHeight": 18
  },
  "font_grade_8_regular": {
    "fontSize": 12,
    "fontWeight": "Regular",
    "lineHeight": 18
  },
  "font_grade_9_medium": {
    "fontSize": 11,
    "fontWeight": "Medium",
    "lineHeight": 16
  },
  "font_grade_9_regular": {
    "fontSize": 11,
    "fontWeight": "Regular",
    "lineHeight": 16
  },
  "font_grade_10_medium": {
    "fontSize": 10,
    "fontWeight": "Medium",
    "lineHeight": 15
  },
  "font_grade_10_regular": {
    "fontSize": 10,
    "fontWeight": "Regular",
    "lineHeight": 15
  },
  "font_grade_11_medium": {
    "fontSize": 9,
    "fontWeight": "Medium",
    "lineHeight": 14
  },
  "font_grade_11_regular": {
    "fontSize": 9,
    "fontWeight": "Regular",
    "lineHeight": 14
  },
  "font_grade_12_medium": {
    "fontSize": 7,
    "fontWeight": "Medium",
    "lineHeight": 10
  },
  "font_grade_12_regular": {
    "fontSize": 7,
    "fontWeight": "Regular",
    "lineHeight": 10
  },
  "font_din_24": {
    "fontSize": 24,
    "fontWeight": "Regular",
    "lineHeight": 34,
    "fontFamily": "Alte DIN 1451 Mittelschrift"
  },
  "font_din_20": {
    "fontSize": 20,
    "fontWeight": "Regular",
    "lineHeight": 28,
    "fontFamily": "Alte DIN 1451 Mittelschrift"
  },
  "font_din_18": {
    "fontSize": 18,
    "fontWeight": "Regular",
    "lineHeight": 26,
    "fontFamily": "Alte DIN 1451 Mittelschrift"
  },
  "font_din_17": {
    "fontSize": 17,
    "fontWeight": "Regular",
    "lineHeight": 25,
    "fontFamily": "Alte DIN 1451 Mittelschrift"
  },
  "font_din_16": {
    "fontSize": 16,
    "fontWeight": "Regular",
    "lineHeight": 24,
    "fontFamily": "Alte DIN 1451 Mittelschrift"
  },
  "font_din_15": {
    "fontSize": 15,
    "fontWeight": "Regular",
    "lineHeight": 23,
    "fontFamily": "Alte DIN 1451 Mittelschrift"
  },
  "font_din_14": {
    "fontSize": 14,
    "fontWeight": "Regular",
    "lineHeight": 21,
    "fontFamily": "Alte DIN 1451 Mittelschrift"
  },
  "font_din_12": {
    "fontSize": 12,
    "fontWeight": "Regular",
    "lineHeight": 18,
    "fontFamily": "Alte DIN 1451 Mittelschrift"
  },
  "dialog_title": {
    "fontSize": 18,
    "fontWeight": "Medium",
    "lineHeight": 21
  },
  "font_grade_7c_medium": {
    "fontSize": 13,
    "fontWeight": "Medium",
    "lineHeight": 20
  },
  "font_grade_7c_regular": {
    "fontSize": 13,
    "fontWeight": "Regular",
    "lineHeight": 20
  },
  "primary_title": {
    "fontSize": 24,
    "fontWeight": "Medium",
    "lineHeight": 30
  },
  "sub_title": {
    "fontSize": 20,
    "fontWeight": "Medium",
    "lineHeight": 24
  },
  "secondary_title": {
    "fontSize": 17,
    "fontWeight": "Medium",
    "lineHeight": 21
  },
  "list_title": {
    "fontSize": 16,
    "fontWeight": "Medium",
    "lineHeight": 24
  },
  "plain_text": {
    "fontSize": 15,
    "fontWeight": "Medium",
    "lineHeight": 23
  },
  "description_text": {
    "fontSize": 14,
    "fontWeight": "Medium",
    "lineHeight": 21
  },
  "auxiliary_text": {
    "fontSize": 12,
    "fontWeight": "Regular",
    "lineHeight": 18
  },
  "least_text": {
    "fontSize": 10,
    "fontWeight": "Regular",
    "lineHeight": 12
  },
  "font_title_log_in": {
    "fontSize": 22,
    "fontWeight": "Medium",
    "lineHeight": 31
  },
  "font_text_growth": {
    "fontSize": 8,
    "fontWeight": "Medium",
    "lineHeight": 11
  }
}
